// src/services/stationService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getStations = async () => {
  return await axios.get(`${API_URL}/stations`);
};

const getStation = async (id) => {
  return await axios.get(`${API_URL}/stations/${id}`);
};

const createStation = async (stationData) => {
  return await axios.post(`${API_URL}/stations`, stationData);
};

const updateStation = async (id, stationData) => {
  return await axios.put(`${API_URL}/stations/${id}`, stationData);
};

const deleteStation = async (id) => {
  return await axios.delete(`${API_URL}/stations/${id}`);
};

const getAmbulances = async () => {
  return await axios.get(`${API_URL}/stations?station_type=ambulance`);
};

const updateAmbulanceLocation = async (id, locationData) => {
  return await axios.put(`${API_URL}/stations/${id}/location`, locationData);
};

const getAmbulanceLocationHistory = async (id) => {
  return await axios.get(`${API_URL}/stations/${id}/location-history`);
};


export default {
  getAmbulances,
  updateAmbulanceLocation,
  getAmbulanceLocationHistory,
  getStations,
  getStation,
  createStation,
  updateStation,
  deleteStation,
};
